import React from "react";

export default function DashboardPage() {
    return <h2>Dashboard Page</h2>;
}
